import React from "react";

interface LoadVideoProps {
    className: string;
    url: string | null;
}

const LoadVideo: React.FC<LoadVideoProps> = ({ url, className }) => {
    if (!url || url.trim() === "") {
        return null;
    }

    return (
        <div className={className}>
            <video
                className="h-full rounded-lg"
                controls
                src={url}>
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default LoadVideo;